var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import PropTypes from "prop-types";
import { css } from "styled-components";
import { map } from "../../breakpoint";
export var lineHeight = function lineHeight(props) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref) {
    var lineHeight = _ref.lineHeight;
    return map(lineHeight, function (val) {
      return val !== undefined && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          line-height: ", ";\n        "])), val);
    });
  });
};
export var lineHeightPropType = PropTypes.string;
export var lineHeightPropTypeMap = PropTypes.oneOfType([lineHeightPropType, PropTypes.shape({
  xs: lineHeightPropType,
  sm: lineHeightPropType,
  md: lineHeightPropType,
  lg: lineHeightPropType,
  xl: lineHeightPropType,
  xxl: lineHeightPropType,
  xxxl: lineHeightPropType
})]);